import LifeLine from "../../../views/LifeLine";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const LifeLineRoutes = [
  {
    menuName: MenuNames.LIFELINE,
    path: "/lifeline",
    component: LifeLine,
    exact: true,
  },
  {
    menuName: MenuNames.LIFELINE,
    path: "/lifeline/:filter_type/:filter_value",
    component: LifeLine,
    exact: true,
  },
];

export default LifeLineRoutes;
